// El directo: un EventSource sobre /api/v1/stream. Cada evento «cambio» invalida solo las
// lecturas afectadas. Si el flujo cae, EventSource reintenta solo (retry 3 s) y, mientras
// tanto, las lecturas vuelven a un sondeo de 30 s para no mostrar datos viejos en silencio.
import { useEffect, useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { DEPENDENCIAS } from "./datos";

export type EstadoDirecto = "conectando" | "conectado" | "reconectando";

export function useDirecto(activo: boolean, alSalir: () => void): EstadoDirecto {
  const qc = useQueryClient();
  const [estado, setEstado] = useState<EstadoDirecto>("conectando");

  useEffect(() => {
    if (!activo || typeof EventSource === "undefined") return;
    const es = new EventSource("/api/v1/stream");
    let sondeo: number | undefined;
    const pararSondeo = () => { if (sondeo) { window.clearInterval(sondeo); sondeo = undefined; } };

    es.addEventListener("hola", () => { setEstado("conectado"); pararSondeo(); });
    es.addEventListener("cambio", (ev) => {
      try {
        const { que } = JSON.parse((ev as MessageEvent).data) as { que: string[] };
        const rutas = new Set(que.flatMap((q) => DEPENDENCIAS[q] ?? []));
        rutas.forEach((r) => qc.invalidateQueries({ queryKey: [r] }));
      } catch {
        qc.invalidateQueries();
      }
    });
    es.addEventListener("salir", () => { es.close(); alSalir(); });
    es.onerror = () => {
      setEstado("reconectando");
      if (!sondeo) sondeo = window.setInterval(() => qc.invalidateQueries(), 30_000);
    };
    return () => { pararSondeo(); es.close(); };
  }, [activo, qc, alSalir]);

  return estado;
}
